/**
 * The single source of truth for which NEC edition this engine encodes.
 * Every UI surface (app screen + web page) MUST display this string so the
 * user always knows which code year the numbers are based on. Changing
 * editions is a deliberate, tested feature — never a silent patch.
 */
export const NEC_EDITION = "NEC 2023" as const;
export type NecEdition = typeof NEC_EDITION;
